import { AssistantTab } from '@core/models/assistant/assistant.model';

/**
 * The user's earlier prompts, newest first: the open tab's, then the other tabs' from the most recently
 * created. A prompt sent more than once appears once, at its newest place.
 */
export function promptHistory(tabs: readonly AssistantTab[], activeId: string): string[] {
  const ordered = [
    ...tabs.filter((t) => t.id === activeId),
    ...tabs.filter((t) => t.id !== activeId).reverse()
  ];
  const seen = new Set<string>();
  const prompts: string[] = [];
  for (const tab of ordered) {
    for (const message of [...tab.messages].reverse()) {
      const text = message.text.trim();
      if (message.role !== 'user' || !text || seen.has(text)) continue;
      seen.add(text);
      prompts.push(text);
    }
  }
  return prompts;
}
